const baseUrl = "https://stomareas.onrender.com";
//const baseUrl = "http://localhost:5000";
export default baseUrl;
